import * as React from "react";
const SvgSquareFull = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 0H0V18H18V0Z", fill: "#212121" }));
export default SvgSquareFull;
